/**
 * User-friendly error messages for the application
 *
 * These messages are shown to end users and should never expose
 * technical details or raw error messages from the backend/APIs.
 */

// Type Well Error Messages
export const SAVE_TYPE_WELL_ERROR_MESSAGE =
  "An error occurred while saving the type well. Please try again.";
export const CLONE_TYPE_WELL_ERROR_MESSAGE =
  "Failed to clone type well. Please try again.";
